/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-11-24 15:01:25
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-11-26 08:47:56
 */

import { ActionType, CustomAction } from '../../global'

// 电商供应商订单-开票状态
export const ToDoState = [
  { name: '当前待办', value: '1', color: '#52C41A' },
  { name: '已完结', value: '2', color: 'red' },
] as const
export type InvoiceType = (typeof ToDoState)[number]['value']
export type invoiceTabKey = (typeof ToDoState)[number]['name']
export type invoiceStateKey = InvoiceType

export type RadioDict = {
  [x in invoiceTabKey]?: {
    key: invoiceStateKey
    keyName: invoiceStateKey // 传入接口的值
    value: string
  }
}
export interface paginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: invoiceTabKey // 当前选中tab的key值
  dataSource: any[]
  isTableLoading?: boolean
  pagination: paginationOption
  searchParam: any
}

export const initialRadioDict: RadioDict = {
  当前待办: {
    key: '1',
    keyName: '1',
    value: '当前待办（0）',
  },
  已完结: {
    key: '2',
    keyName: '2',
    value: '已完结',
  },
}

export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '当前待办',
  dataSource: [],
  isTableLoading: false,
  pagination: {
    total: 100,
    current: 1,
    pagesize: 10,
  },
  searchParam: {},
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKeyAction':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPaginationAction':
      newstate.pagination = action.payload
      return newstate
    case 'setCurrentRadioDictAction':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParamAction = (val: any): CustomAction<Action> => ({
  type: 'setSearchParamAction',
  payload: val,
})

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDictAction = (val: any): CustomAction<Action> => ({
  type: 'setCurrentRadioDictAction',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKeyAction = (
  val: React.Key,
): CustomAction<Action> => ({
  type: 'setCheckedRadioKeyAction',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationAction = (
  val: paginationOption,
): CustomAction<Action> => ({
  type: 'setPaginationAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any[]): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})
/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-11-24 15:01:25
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-11-26 08:47:56
 */

import { ActionType, CustomAction } from '../../global'

// 电商供应商订单-开票状态
export const ToDoState = [
  { name: '当前待办', value: '1', color: '#52C41A' },
  { name: '已完结', value: '2', color: 'red' },
] as const
export type InvoiceType = (typeof ToDoState)[number]['value']
export type invoiceTabKey = (typeof ToDoState)[number]['name']
export type invoiceStateKey = InvoiceType

export type RadioDict = {
  [x in invoiceTabKey]?: {
    key: invoiceStateKey
    keyName: invoiceStateKey // 传入接口的值
    value: string
  }
}
export interface paginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: invoiceTabKey // 当前选中tab的key值
  dataSource: any[]
  isTableLoading?: boolean
  pagination: paginationOption
  searchParam: any
}

export const initialRadioDict: RadioDict = {
  当前待办: {
    key: '1',
    keyName: '1',
    value: '当前待办（0）',
  },
  已完结: {
    key: '2',
    keyName: '2',
    value: '已完结',
  },
}

export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '当前待办',
  dataSource: [],
  isTableLoading: false,
  pagination: {
    total: 100,
    current: 1,
    pagesize: 10,
  },
  searchParam: {},
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKeyAction':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPaginationAction':
      newstate.pagination = action.payload
      return newstate
    case 'setCurrentRadioDictAction':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setSearchParamAction = (val: any): CustomAction<Action> => ({
  type: 'setSearchParamAction',
  payload: val,
})

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDictAction = (val: any): CustomAction<Action> => ({
  type: 'setCurrentRadioDictAction',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKeyAction = (
  val: React.Key,
): CustomAction<Action> => ({
  type: 'setCheckedRadioKeyAction',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationAction = (
  val: paginationOption,
): CustomAction<Action> => ({
  type: 'setPaginationAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any[]): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})
